// import React, { useEffect, useRef } from "react";
// import { Container, Table, Button, Spinner, Row, Col } from "react-bootstrap";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   fetchAlertsByUser,
//   acknowledgeAlertById,
// } from "../../redux/slices/AlertSlice";
// import NavbarComponent from "./SenseNavBar";
// import Footer from "./Footer";
// import { useNavigate } from "react-router-dom";
// import "./UserCSS/custom.css";

// function UserAlerts() {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   // Redux state
//   const alerts = useSelector((state) => state.alerts.alerts);
//   const loading = useSelector((state) => state.alerts.loading);
//   const user = useSelector((state) => state.auth.user);
//   const initialized = useRef(false);

//   // Fetch alerts on mount and when user changes
//   useEffect(() => {
//     if (user) {
//       console.log("Dispatching fetchAlertsByUser with user_id:", user.user_id); // Debug
//       dispatch(fetchAlertsByUser(user.user_id));
//     }
//   }, [dispatch, user]);

//   useEffect(() => {
//     if (alerts.length > 0 && !initialized.current) {
//       initialized.current = true;
//     }
//   }, [alerts]);

//   const handleAcknowledge = (alertId) => {
//     dispatch(acknowledgeAlertById(alertId));
//   };

//   const handleBackToDashboard = () => {
//     navigate("/dashboard");
//   };

//   return (
//     <div className="dashboard-wrapper">
//       <NavbarComponent />
//       <Container
//         fluid
//         className="dashboard-content"
//         style={{ minHeight: "60vh" }}
//       >
//         <Row className="justify-content-center">
//           <Col md={10} lg={8}>
//             <h2 className="text-center mb-4" style={{ fontWeight: "bold" }}>
//               Patient Help Alerts
//             </h2>
//             <Button variant="secondary" onClick={handleBackToDashboard}>
//               Back
//             </Button>
//           </Col>
//         </Row>
//         {!initialized.current && loading ? (
//           <div className="text-center">
//             <Spinner animation="grow" variant="primary" />
//             <p>Loading alerts...</p>
//           </div>
//         ) : (
//           <Row className="justify-content-center mt-4">
//             <Col md={10} lg={8}>
//               <div style={{ maxHeight: "500px", overflowY: "auto" }}>
//                 <Table striped bordered hover responsive>
//                   <thead>
//                     <tr>
//                       <th>Time</th>
//                       <th>Patient ID</th>
//                       <th>Alert Content</th>
//                       <th>Status</th>
//                       <th>Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {alerts && alerts.length > 0 ? (
//                       alerts.map((alert) => (
//                         <tr key={alert.id}>
//                           <td>{new Date(alert.time).toLocaleString()}</td>
//                           <td>{alert.patient_id}</td>
//                           <td>{alert.alert_content}</td>
//                           <td>{alert.acknowledged ? "Acknowledged" : "New"}</td>
//                           <td>
//                             {!alert.acknowledged ? (
//                               <Button
//                                 variant="success"
//                                 size="sm"
//                                 onClick={() => handleAcknowledge(alert.id)}
//                               >
//                                 Acknowledge
//                               </Button>
//                             ) : (
//                               <span
//                                 style={{ color: "green", fontWeight: "bold" }}
//                               >
//                                 &#10003; {/* checkmark */}
//                               </span>
//                             )}
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="5" className="text-center">
//                           No alerts found
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </Table>
//               </div>
//             </Col>
//           </Row>
//         )}
//       </Container>
//       <Footer />
//     </div>
//   );
// }

// export default UserAlerts;



// src/components/User/UserAlerts.js
import React, { useEffect, useState } from "react";
import {
  Container,
  Table,
  Button,
  Spinner,
  Row,
  Col,
  Modal,
  Form,
  Badge,
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  fetchFallAlertsByUser,
  acknowledgeFallAlertById,
} from "../../redux/slices/AlertTableSlice";

import {
  fetchAlertsByUser as fetchWatchAlertsByUser,
  acknowledgeAlertById as acknowledgeWatchAlertById,
} from "../../redux/slices/AlertSlice";

import NavbarComponent from "./SenseNavBar";
import Footer from "./Footer";
import "./UserCSS/custom.css";
import "./UserCSS/UserAlerts.css";

const TH_STYLE = { backgroundColor: "#000000", color: "#ffffff" };

// ─────────────────────────────────────────────────────────────
// TAB 1 — Fall Alerts (UPDATED with SAS + Per-button loading)
// ─────────────────────────────────────────────────────────────
function FallAlertsTab({ user }) {
  const dispatch = useDispatch();

  const fallAlerts = useSelector((state) => state.fallAlerts.alerts);
  const loading = useSelector((state) => state.fallAlerts.loading);
  const error = useSelector((state) => state.fallAlerts.error);

  // FIXED: Same state as Admin panel
  const [showAckModal, setShowAckModal] = useState(false);
  const [ackTarget, setAckTarget] = useState({ alertId: null, note: "" });
  const [showEvidenceModal, setShowEvidenceModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [currentVideoAlertId, setCurrentVideoAlertId] = useState(null); // Per-button loading
  const [videoLoading, setVideoLoading] = useState(false);

  useEffect(() => {
    if (user) dispatch(fetchFallAlertsByUser(user.user_id));
  }, [dispatch, user]);

  // FIXED: Fetch SAS URL (same as Admin)
  const fetchVideoUrl = async (alertId) => {
    setCurrentVideoAlertId(alertId);
    setVideoLoading(true);
    try {
      const apiUrl = `${process.env.REACT_APP_API_URL}/alerts_table/evidence-url/${alertId}`;
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP ${response.status}`);
      }
      
      const data = await response.json();
      setVideoUrl(data.sas_url);
    } catch (err) {
      console.error("Video fetch failed:", err);
      setVideoUrl("");
    } finally {
      setVideoLoading(false);
    }
  };

  const openAckModal = (alertId) => {
    setAckTarget({ alertId, note: "" });
    setShowAckModal(true);
  };

  const handleConfirmAcknowledge = () => {
    dispatch(
      acknowledgeFallAlertById({
        alertId: ackTarget.alertId,
        alert_acknowledged: true,
        note: ackTarget.note,
        user_id: user?.user_id,
      })
    );
    setShowAckModal(false);
  };

  // FIXED: Open video modal with SAS URL
  const openEvidenceModal = async (alertId) => {
    await fetchVideoUrl(alertId);
    setShowEvidenceModal(true);
  };

  const closeEvidenceModal = () => {
    setShowEvidenceModal(false);
    setVideoUrl("");
    setCurrentVideoAlertId(null);
  };

  // FIXED: Check if THIS specific button should show loading
  const isButtonLoading = (alertId) => currentVideoAlertId === alertId && videoLoading;

  if (loading) {
    return (
      <div className="text-center mt-4">
        <Spinner animation="grow" variant="primary" />
        <p className="mt-2">Loading fall alerts…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center mt-4 text-danger">
        Failed to load fall alerts: {error}
      </div>
    );
  }

  return (
    <>
      <div style={{ maxHeight: "500px", overflowY: "auto" }}>
        <Table striped bordered hover responsive className="custom-table">
          <thead>
            <tr>
              <th style={TH_STYLE}>Time</th>
              <th style={TH_STYLE}>Patient ID</th>
              <th style={TH_STYLE}>Event</th>
              <th style={TH_STYLE}>Reason</th>
              <th style={TH_STYLE}>Status</th>
              <th style={TH_STYLE}>Note</th>
              <th style={TH_STYLE}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {fallAlerts && fallAlerts.length > 0 ? (
              fallAlerts.map((alert) => (
                <tr key={alert.alert_id}>
                  <td>{new Date(alert.occurred_at).toLocaleString()}</td>
                  <td>{alert.patient_id}</td>
                  <td>
                    <Badge bg="secondary">{alert.event_type}</Badge>
                  </td>
                  <td>{alert.reason || "—"}</td>
                  <td>
                    {alert.alert_acknowledged ? (
                      <span className="text-success fw-bold">Acknowledged</span>
                    ) : (
                      <span className="text-danger fw-bold">New</span>
                    )}
                  </td>
                  <td
                    style={{
                      maxWidth: "160px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {alert.note || "—"}
                  </td>
                  <td>
                    <div className="d-flex gap-1 flex-wrap">
                      {!alert.alert_acknowledged && (
                        <Button
                          variant="success"
                          size="sm"
                          onClick={() => openAckModal(alert.alert_id)}
                        >
                          Acknowledge
                        </Button>
                      )}
                      {alert.alert_acknowledged && (
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          ✓
                        </span>
                      )}
                      {alert.evidence_path && (
                        <Button
                          variant="primary"
                          size="sm"
                          onClick={() => openEvidenceModal(alert.alert_id)} // FIXED: Pass alertId
                          disabled={isButtonLoading(alert.alert_id)} // FIXED: Per-button loading
                        >
                          {isButtonLoading(alert.alert_id) ? (
                            <>
                              <Spinner as="span" animation="border" size="sm" />
                              <span style={{ marginLeft: "5px" }}>Loading...</span>
                            </>
                          ) : (
                            "View Evidence"
                          )}
                        </Button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center text-muted fst-italic py-4">
                  No fall alerts found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Acknowledge Modal */}
      <Modal show={showAckModal} onHide={() => setShowAckModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Acknowledge Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted mb-3">Optionally add a note before confirming.</p>
          <Form.Group>
            <Form.Label>Note (optional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter a note…"
              value={ackTarget.note}
              onChange={(e) =>
                setAckTarget((prev) => ({ ...prev, note: e.target.value }))
              }
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAckModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleConfirmAcknowledge}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      {/* FIXED Video Modal - Wide + Clean + SAS */}
      <Modal
        show={showEvidenceModal}
        onHide={closeEvidenceModal}
        centered
        className="video-modal-xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Fall Evidence Video</Modal.Title>
        </Modal.Header>
        <Modal.Body className="video-modal-body">
          {videoLoading ? (
            <div className="video-loading">
              <Spinner animation="border" size="lg" />
              <p>Loading video...</p>
            </div>
          ) : !videoUrl ? (
            <div className="no-video">
              <p>No video available</p>
            </div>
          ) : (
            <div className="video-container">
              <video
                className="evidence-video"
                controls
                preload="metadata"
                src={videoUrl}
                playsInline
              />
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

// ─────────────────────────────────────────────────────────────
// TAB 2 — Watch Alerts (UNCHANGED)
// ─────────────────────────────────────────────────────────────
function WatchAlertsTab({ user }) {
  const dispatch = useDispatch();

  const watchAlerts = useSelector((state) => state.alerts.alerts);
  const loading = useSelector((state) => state.alerts.loading);
  const error = useSelector((state) => state.alerts.error);

  useEffect(() => {
    if (user) dispatch(fetchWatchAlertsByUser(user.user_id));
  }, [dispatch, user]);

  const handleAcknowledge = (alertId) => {
    dispatch(acknowledgeWatchAlertById(alertId));
  };

  if (loading) {
    return (
      <div className="text-center mt-4">
        <Spinner animation="grow" variant="primary" />
        <p className="mt-2">Loading watch alerts…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center mt-4 text-danger">
        Failed to load watch alerts: {error}
      </div>
    );
  }

  return (
    <div style={{ maxHeight: "500px", overflowY: "auto" }}>
      <Table striped bordered hover responsive className="custom-table">
        <thead>
          <tr>
            <th style={TH_STYLE}>Time</th>
            <th style={TH_STYLE}>Patient ID</th>
            <th style={TH_STYLE}>Alert Content</th>
            <th style={TH_STYLE}>Status</th>
            <th style={TH_STYLE}>Action</th>
          </tr>
        </thead>
        <tbody>
          {watchAlerts && watchAlerts.length > 0 ? (
            watchAlerts.map((alert) => (
              <tr key={alert.id}>
                <td>{new Date(alert.time).toLocaleString()}</td>
                <td>{alert.patient_id}</td>
                <td>{alert.alert_content}</td>
                <td>
                  {alert.acknowledged ? (
                    <span className="text-success fw-bold">Acknowledged</span>
                  ) : (
                    <span className="text-danger fw-bold">New</span>
                  )}
                </td>
                <td>
                  {!alert.acknowledged ? (
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() => handleAcknowledge(alert.id)}
                    >
                      Acknowledge
                    </Button>
                  ) : (
                    <span style={{ color: "green", fontWeight: "bold" }}>
                      ✓
                    </span>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center text-muted fst-italic py-4">
                No watch alerts found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────
// MAIN PAGE (UNCHANGED)
// ─────────────────────────────────────────────────────────────
function UserAlerts() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);

  const [activeTab, setActiveTab] = useState("fall");

  const fallLoading = useSelector((state) => state.fallAlerts.loading);
  const watchLoading = useSelector((state) => state.alerts.loading);
  const fallAlerts = useSelector((state) => state.fallAlerts.alerts);
  const watchAlerts = useSelector((state) => state.alerts.alerts);

  const fallUnread = fallLoading ? 0 : fallAlerts.filter((a) => !a.alert_acknowledged).length;
  const watchUnread = watchLoading ? 0 : watchAlerts.filter((a) => !a.acknowledged).length;

  return (
    <div className="dashboard-wrapper">
      <NavbarComponent />

      <Container fluid className="dashboard-content" style={{ minHeight: "60vh" }}>
        <Row className="justify-content-center">
          <Col md={10} lg={10}>
            <div className="d-flex align-items-center justify-content-between mb-3 mt-3">
              <h2 style={{ fontWeight: "bold", marginBottom: 0 }}>
                Patient Help Alerts
              </h2>
              <Button variant="secondary" onClick={() => navigate("/dashboard")}>
                Back
              </Button>
            </div>

            <div className="ua-tab-bar">
              <button
                className={`ua-tab-btn ${activeTab === "fall" ? "ua-tab-btn--active" : ""}`}
                onClick={() => setActiveTab("fall")}
              >
                Fall Alerts
                {fallUnread > 0 && (
                  <span className="ua-unread-badge">{fallUnread}</span>
                )}
              </button>
              <button
                className={`ua-tab-btn ${activeTab === "watch" ? "ua-tab-btn--active" : ""}`}
                onClick={() => setActiveTab("watch")}
              >
                Watch Alerts
                {watchUnread > 0 && (
                  <span className="ua-unread-badge">{watchUnread}</span>
                )}
              </button>
            </div>

            <div className="ua-tab-content">
              {activeTab === "fall" ? (
                <FallAlertsTab user={user} />
              ) : (
                <WatchAlertsTab user={user} />
              )}
            </div>
          </Col>
        </Row>
      </Container>

      <Footer />
    </div>
  );
}

export default UserAlerts;